import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsAutomationPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.workspace?.automation || [];
  return (
    <NotesMainPanel
      title={t('settingsPages.automationTitle')}
      subtitle={t('settingsPages.automationSubtitle')}
      items={items}
      emptyTitle={t('settingsPages.automationEmpty')}
    />
  );
}
